// extracted by mini-css-extract-plugin
export default {"priceChangeContainer":"PriceChange_priceChangeContainer__azIv+","riseInValue":"PriceChange_riseInValue__oXxrA","fallInValue":"PriceChange_fallInValue__x8QJr"};